export async function getBlobByFileName (blobs, fileName) {
  return await getBlobByPredicate(
    blobs,
    (blob) => blob.value.name.split('/').pop() === fileName
  )
}

export async function getBlobByFileExtension (blobs, fileExtension) {
  return await getBlobByPredicate(
    blobs,
    (blob) => blob.value.name.split('.').pop() === fileExtension
  )
}

async function getBlobByPredicate (blobs, predicate) {
  let blob = await blobs.next()
  while (blob?.value?.name) {
    if (predicate(blob)) {
      return blob
    } else {
      blob = await blobs.next()
    }
  }
  return undefined
}
